import { render, staticRenderFns } from "./ModuleConfig.vue?vue&type=template&id=9a64a518&scoped=true&"
import script from "./ModuleConfig.vue?vue&type=script&lang=js&"
export * from "./ModuleConfig.vue?vue&type=script&lang=js&"
import style0 from "./ModuleConfig.vue?vue&type=style&index=0&id=9a64a518&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a64a518",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VProgressCircular})
